import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { testimonials } from '../data/content';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="border-b border-line bg-surface/40" data-id="element-143" data-mp="3ayi09lag3jqs">
      <div className="mx-auto max-w-3xl px-4 py-8 sm:py-10" data-id="element-144" data-mp="370aiqo85qeej">
        <SectionHeader id="testimonios" title="Lo que dicen quienes ya empezaron" description="De no saber por dónde comenzar a comprender cómo funciona un sistema de seguridad perimetral." data-id="element-145" data-mp="31zmrq2jxhxkb" />
        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-146" data-mp="2s39qmjm20hfj">
          {testimonials.map((t, i) => <li key={t.author} className={`flex flex-col rounded-xl border border-line bg-surface p-3.5 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-147" data-mp="v8wvafg59ufc" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-148" data-mp="m51e408lhlc4">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} aria-hidden="true" className="fill-accent text-accent" data-id="element-149" data-mp="78ttiyt9yhwb" data-mpi={j} />)}
              </div>
              <blockquote className="mt-2 text-[0.8rem] leading-snug text-ink sm:text-sm" data-id="element-150" data-mp="c8y304vrmcd1">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-3" data-id="element-151" data-mp="14vsiendq6ljn">
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-accent font-display text-xs font-extrabold text-canvas" data-id="element-152" data-mp="q6ml54yg75ee">
                  {initials(t.author)}
                </span>
                <div className="min-w-0" data-id="element-153" data-mp="1iv1yzo5ufho5">
                  <p className="font-display text-sm font-extrabold text-ink" data-id="element-154" data-mp="1itzatnzwntbx">{t.author}</p>
                  <p className="text-xs leading-tight text-muted" data-id="element-155" data-mp="1nnlb0govu4qu">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
        <CtaBlock data-id="element-156" data-mp="1sied79ovgvu2" />
      </div>
    </section>;
}